"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUserSessionRequestDTO = exports.createUserSessionRequestDTO = void 0;
const createUserSessionRequestDTO = marketingId => ({
  processFlowSpecification: 'questionnaireState',
  characteristic: [{
    name: 'questionnaireState',
    value: '',
    valueType: 'String'
  }],
  relatedParty: [{
    id: marketingId,
    '@referredType': 'individual'
  }]
});
exports.createUserSessionRequestDTO = createUserSessionRequestDTO;
const updateUserSessionRequestDTO = sessionState => {
  const value = {
    ...sessionState
  };
  return {
    completionMethod: 'userinput',
    taskFlowSpecification: 'question-set-id+question-number',
    characteristic: [{
      name: 'questionnaireState',
      valueType: 'string',
      value: sessionState ? JSON.stringify(value) : ''
    }]
  };
};
exports.updateUserSessionRequestDTO = updateUserSessionRequestDTO;